import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const productService = {
	getProductsRequired,
	getProductsNeeded,
	getProductsForecast,
	getProductsCogs,
	saveCogsData,
	getCogsSaves,
	loadCogSave,
	downloadCogs,
	getProductSyncStatus,
}

function getProductsRequired() {
		const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/products/required`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getProductsCogs(startDate, endDate) {
		const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/products/cogs?StartDate=${startDate}&EndDate=${endDate}`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getProductsNeeded(date) {
		const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	let dateString = date ? date.toISOString() : '0';
	return fetch(BASE_URL + `/products/needed/` + dateString, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getProductsForecast() {
		const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/products/forecast`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function saveCogsData(name, data) {
		const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify({
			name: name,
			data: data
		})
	};

	return fetch(BASE_URL + `/products/cogs/save`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getCogsSaves() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/products/cogs/save`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function loadCogSave(id) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/products/cogs/load/${id}`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function downloadCogs(data, format) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify({data: data, format: format})
	};

	return fetch(BASE_URL + `/products/cogs/download`, requestOptions)
		// .then(handleResponse)
		.then(response => {
			return response.blob();
		});
}

function getProductSyncStatus(account = 'retail', includeArchived = false) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/products/sync-status?account=${encodeURIComponent(account)}&includeArchived=${includeArchived ? 'true' : 'false'}`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}